import type { RequestSettings } from '@core/entities/RequestSettings';

export interface RequestSettingsResponse {
  http_version?: string;
  ssl_verification?: boolean;
  follow_redirects?: boolean;
  follow_original_http_method?: boolean;
  follow_authorization_header?: boolean;
  remove_referer_on_redirect?: boolean;
  max_redirects?: number;
  encode_url_automatically?: boolean;
  disable_cookie_jar?: boolean;
  min_tls_version?: string;
  cipher_suite?: string | null;
}

export const toRequestSettings = (
  payload: RequestSettingsResponse | null | undefined,
): RequestSettings => {
  if (!payload) return {};
  const settings: RequestSettings = {};
  if (payload.http_version !== undefined)
    settings.httpVersion = payload.http_version as RequestSettings['httpVersion'];
  if (payload.ssl_verification !== undefined) settings.sslVerification = payload.ssl_verification;
  if (payload.follow_redirects !== undefined) settings.followRedirects = payload.follow_redirects;
  if (payload.follow_original_http_method !== undefined)
    settings.followOriginalHttpMethod = payload.follow_original_http_method;
  if (payload.follow_authorization_header !== undefined)
    settings.followAuthorizationHeader = payload.follow_authorization_header;
  if (payload.remove_referer_on_redirect !== undefined)
    settings.removeRefererOnRedirect = payload.remove_referer_on_redirect;
  if (payload.max_redirects !== undefined) settings.maxRedirects = payload.max_redirects;
  if (payload.encode_url_automatically !== undefined)
    settings.encodeUrlAutomatically = payload.encode_url_automatically;
  if (payload.disable_cookie_jar !== undefined)
    settings.disableCookieJar = payload.disable_cookie_jar;
  if (payload.min_tls_version !== undefined)
    settings.minTlsVersion = payload.min_tls_version as RequestSettings['minTlsVersion'];
  if (payload.cipher_suite !== undefined) settings.cipherSuite = payload.cipher_suite;
  return settings;
};

export const toRequestSettingsPayload = (settings: RequestSettings): RequestSettingsResponse => {
  const payload: RequestSettingsResponse = {};
  if (settings.httpVersion !== undefined) payload.http_version = settings.httpVersion;
  if (settings.sslVerification !== undefined) payload.ssl_verification = settings.sslVerification;
  if (settings.followRedirects !== undefined) payload.follow_redirects = settings.followRedirects;
  if (settings.followOriginalHttpMethod !== undefined)
    payload.follow_original_http_method = settings.followOriginalHttpMethod;
  if (settings.followAuthorizationHeader !== undefined)
    payload.follow_authorization_header = settings.followAuthorizationHeader;
  if (settings.removeRefererOnRedirect !== undefined)
    payload.remove_referer_on_redirect = settings.removeRefererOnRedirect;
  if (settings.maxRedirects !== undefined) payload.max_redirects = settings.maxRedirects;
  if (settings.encodeUrlAutomatically !== undefined)
    payload.encode_url_automatically = settings.encodeUrlAutomatically;
  if (settings.disableCookieJar !== undefined)
    payload.disable_cookie_jar = settings.disableCookieJar;
  if (settings.minTlsVersion !== undefined) payload.min_tls_version = settings.minTlsVersion;
  if (settings.cipherSuite !== undefined) payload.cipher_suite = settings.cipherSuite;
  return payload;
};
